import { CommandBarButton, IButtonProps, IconButton as FabricIconButton, TooltipHost } from "@fluentui/react";
import * as React from "react";

export type DeliveryInfoButtonProps = Pick<IButtonProps, "id" | "disabled" | "onClick" | "styles"> & {
    isLabeled?: boolean;
};

export const DeliveryInfoButton: React.FC<DeliveryInfoButtonProps> = (props: DeliveryInfoButtonProps) => {
    return (
        <>
            {props.isLabeled ? (
                <CommandBarButton
                    key={props.id}
                    iconProps={{ iconName: "ProductList" }}
                    disabled={props.disabled}
                    onClick={props.onClick}
                    allowDisabledFocus={false}
                    checked={false}
                    ariaLabel="Delivery info"
                    text="Delivery info"
                    styles={props.styles}
                    data-testId="delivery-info-button"
                />
            ) : (
                <TooltipHost content="Delivery info" styles={{ root: { display: "inline-block" } }}>
                    <FabricIconButton
                        key={props.id}
                        iconProps={{ iconName: "ProductList" }} // or ProductCatalog
                        disabled={props.disabled}
                        onClick={props.onClick}
                        allowDisabledFocus={false}
                        checked={false}
                        ariaLabel="Delivery info"
                        styles={props.styles}
                        data-testId="delivery-info-button"
                    />
                </TooltipHost>
            )}
        </>
    );
};
